import { render, staticRenderFns } from "./botton.vue?vue&type=template&id=4ac5e112&scoped=true"
import script from "./botton.vue?vue&type=script&lang=js"
export * from "./botton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac5e112",
  null
  
)

export default component.exports